// extracted by mini-css-extract-plugin
export default {"container":"Dca-z","oos":"Eca-z","oosUx":"Fca-z","selected":"Gca-z","labelOos":"Hca-z"};